import { render, staticRenderFns } from "./diagram_performance_warning.vue.js?vue&type=template&id=6e7f73a4!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./diagram_performance_warning.vue?vue&type=template&id=6e7f73a4"
import script from "./diagram_performance_warning.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./diagram_performance_warning.vue?vue&type=script&lang=js"
export * from "./diagram_performance_warning.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./diagram_performance_warning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e7f73a4')) {
      api.createRecord('6e7f73a4', component.options)
    } else {
      api.reload('6e7f73a4', component.options)
    }
    module.hot.accept("./diagram_performance_warning.vue.js?vue&type=template&id=6e7f73a4!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./diagram_performance_warning.vue?vue&type=template&id=6e7f73a4", function () {
      api.rerender('6e7f73a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "behaviors/components/diagram_performance_warning.vue"
export default component.exports